(function () {
  const cfg = window.IRUS_KIDS_BOGO;
  if (!cfg || !cfg.enabled) return;

  const FLAG = "irusKidsBogo";
  const COL_KEY = "irusKidsBogoCollection";
  const PRODUCTS_KEY = "irusKidsBogoProducts";
  const modal = document.getElementById("KidsBogoModal");
  const gridEl = document.getElementById("KidsBogoGrid");
  const addBtn = document.getElementById("KidsBogoAdd");
  const searchEl = document.getElementById("KidsBogoSearch");
  const listEl = document.getElementById("KidsBogoList");
  const detailEl = document.getElementById("KidsBogoDetail");
  const detailImg = document.getElementById("KidsBogoDetailImg");
  const detailSku = document.getElementById("KidsBogoDetailSku");
  const detailTitle = document.getElementById("KidsBogoDetailTitle");
  const detailOption = document.getElementById("KidsBogoDetailOption");
  const detailSwatches = document.getElementById("KidsBogoDetailSwatches");
  const detailAdd = document.getElementById("KidsBogoDetailAdd");
  const backBtn = document.getElementById("KidsBogoBack");
  let selected = null;
  let pendingFirst = null;
  let adding = false;
  let productsCache = null;

  const DEFAULT_HANDLE = "irus-edge-kids";

  function kidsHandle() {
    return (cfg.collectionHandle || storedCollection() || DEFAULT_HANDLE).trim();
  }

  function storedCollection() {
    try {
      return sessionStorage.getItem(COL_KEY) || cfg.collectionHandle || DEFAULT_HANDLE;
    } catch (e) {
      return cfg.collectionHandle || DEFAULT_HANDLE;
    }
  }

  function activate(handle) {
    const useHandle = handle || kidsHandle();
    try {
      sessionStorage.setItem(FLAG, "1");
      if (useHandle) sessionStorage.setItem(COL_KEY, useHandle);
      if (cfg.products && cfg.products.length) {
        sessionStorage.setItem(PRODUCTS_KEY, JSON.stringify(cfg.products));
      }
    } catch (e) {}
  }

  function hasSession() {
    try {
      return sessionStorage.getItem(FLAG) === "1";
    } catch (e) {
      return false;
    }
  }

  function hasParam() {
    return new URLSearchParams(location.search).get("bogo") === "1";
  }

  function collectionHandle() {
    return kidsHandle();
  }

  if (cfg.isKidsLanding) {
    activate(kidsHandle());
  }

  function productHasBogoTag(product) {
    const need = String(cfg.requiredTag || "bogo").toLowerCase().trim();
    if (!need) return true;
    return (product.tags || []).some(function (t) {
      return String(t).toLowerCase().trim() === need;
    });
  }

  function formIsBogo(form) {
    if (!form) return false;
    const host = form.closest("[data-kids-bogo-product], product-form");
    return (
      form.getAttribute("data-kids-bogo-product") === "1" ||
      (host && host.getAttribute("data-kids-bogo-product") === "1")
    );
  }

  function availableVariants(product) {
    return (product.variants || []).filter(function (v) {
      return v.available !== false;
    });
  }

  function productImage(product) {
    if (product.image) return product.image;
    if (product.featured_image) return product.featured_image;
    if (product.images && product.images[0]) return product.images[0].src || product.images[0];
    return "";
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function variantSku(variant) {
    return String((variant && variant.sku) || "").trim();
  }

  function variantImage(variant, product) {
    if (variant && variant.image) return variant.image;
    if (variant && variant.featured_image) {
      const img = variant.featured_image;
      return img.src || img;
    }
    return productImage(product);
  }

  function optionLabel(variant) {
    return variant && variant.title && variant.title !== "Default Title" ? variant.title : "";
  }

  function productSearchText(product, variants) {
    const parts = [product.title];
    (variants || product.variants || []).forEach(function (v) {
      parts.push(optionLabel(v), variantSku(v));
    });
    return parts.join(" ").toLowerCase();
  }

  function setFooterCta(ready) {
    if (!addBtn) return;
    addBtn.disabled = !ready;
    addBtn.textContent = "Select a frame to continue.";
  }

  function setSelected(product, variant) {
    selected = {
      variantId: Number(variant.id),
      product: product,
      variant: variant,
    };
    setFooterCta(true);
  }

  function pickCard(card, product, variant) {
    setSelected(product, variant);
    paintCard(card, product, variant);
    markCardSelected(card);
  }

  function paintCard(card, product, variant) {
    const img = card.querySelector(".kids-bogo-card__img");
    const skuEl = card.querySelector(".kids-bogo-sku");
    const optEl = card.querySelector(".kids-bogo-option");
    const src = variantImage(variant, product);
    if (img && src) img.src = src;
    if (skuEl) skuEl.textContent = variantSku(variant);
    if (optEl) optEl.textContent = optionLabel(variant);
    card.querySelectorAll(".kids-bogo-swatch").forEach(function (swatch) {
      swatch.classList.toggle("is-active", Number(swatch.getAttribute("data-id")) === Number(variant.id));
    });
  }

  function markCardSelected(card) {
    if (!gridEl) return;
    gridEl.querySelectorAll(".kids-bogo-card").forEach(function (el) {
      el.classList.toggle("is-selected", el === card);
    });
  }

  function createSwatch(product, variant, onPick) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "kids-bogo-swatch";
    btn.setAttribute("data-id", String(variant.id));
    btn.setAttribute("title", optionLabel(variant) || variantSku(variant) || product.title);
    const src = variantImage(variant, product);
    if (src) {
      const img = document.createElement("img");
      img.src = src;
      img.alt = optionLabel(variant) || variantSku(variant);
      btn.appendChild(img);
    }
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      onPick(variant);
    });
    return btn;
  }

  function showList() {
    if (detailEl) detailEl.hidden = true;
    if (listEl) listEl.hidden = false;
  }

  function paintDetail(product, variant) {
    const src = variantImage(variant, product);
    if (detailImg) {
      detailImg.src = src || "";
      detailImg.alt = product.title;
    }
    if (detailSku) detailSku.textContent = variantSku(variant);
    if (detailTitle) detailTitle.textContent = product.title;
    if (detailOption) detailOption.textContent = optionLabel(variant);
    if (!detailSwatches) return;
    detailSwatches.innerHTML = "";
    availableVariants(product).forEach(function (v) {
      const swatch = createSwatch(product, v, function (picked) {
        setSelected(product, picked);
        paintDetail(product, picked);
      });
      if (Number(v.id) === Number(variant.id)) swatch.classList.add("is-active");
      detailSwatches.appendChild(swatch);
    });
  }

  function openDetail(product, variant) {
    setSelected(product, variant);
    paintDetail(product, variant);
    if (listEl) listEl.hidden = true;
    if (detailEl) detailEl.hidden = false;
  }

  function filterBogoCards() {
    if (!gridEl) return;
    const query = searchEl ? String(searchEl.value || "").trim().toLowerCase() : "";
    const cards = gridEl.querySelectorAll(".kids-bogo-card");
    let visible = 0;
    cards.forEach(function (card) {
      const haystack = card.getAttribute("data-search") || "";
      const match = !query || haystack.indexOf(query) !== -1;
      card.hidden = !match;
      if (match) visible += 1;
    });
    let empty = gridEl.querySelector(".kids-bogo-empty");
    if (!empty) {
      empty = document.createElement("p");
      empty.className = "kids-bogo-empty";
      gridEl.appendChild(empty);
    }
    if (!cards.length) {
      empty.hidden = false;
      empty.textContent = "No styles found in this collection.";
    } else if (!visible) {
      empty.hidden = false;
      empty.textContent = "No SKU matches that search.";
    } else {
      empty.hidden = true;
    }
  }

  function renderGrid(products) {
    if (!gridEl) return;
    gridEl.innerHTML = "";
    selected = null;
    setFooterCta(false);
    if (searchEl) searchEl.value = "";
    showList();

    (products || []).forEach(function (product) {
      const variants = availableVariants(product);
      if (!variants.length) return;
      const first = variants[0];
      let currentVariant = first;
      const card = document.createElement("article");
      card.className = "kids-bogo-card";
      card.setAttribute("data-search", productSearchText(product, variants));

      const media = document.createElement("div");
      media.className = "kids-bogo-card__media";
      const image = variantImage(first, product);
      media.innerHTML =
        '<span class="kids-bogo-card__free">FREE</span>' +
        (image ? '<img class="kids-bogo-card__img" src="' + escapeHtml(image) + '" alt="">' : "");
      media.addEventListener("click", function () {
        pickCard(card, product, currentVariant);
      });

      const body = document.createElement("div");
      body.className = "kids-bogo-card__body";
      body.innerHTML =
        '<p class="kids-bogo-sku">' +
        escapeHtml(variantSku(first)) +
        "</p><h3>" +
        escapeHtml(product.title) +
        "</h3>" +
        '<p class="kids-bogo-option">' +
        escapeHtml(optionLabel(first)) +
        "</p>";

      const swatchWrap = document.createElement("div");
      swatchWrap.className = "kids-bogo-swatches";
      if (variants.length > 1) {
        variants.forEach(function (variant) {
          const swatch = createSwatch(product, variant, function (picked) {
            currentVariant = picked;
            pickCard(card, product, picked);
          });
          if (variant === first) swatch.classList.add("is-active");
          swatchWrap.appendChild(swatch);
        });
        body.appendChild(swatchWrap);
      }

      const actions = document.createElement("div");
      actions.className = "kids-bogo-card__actions";
      const detailsBtn = document.createElement("button");
      detailsBtn.type = "button";
      detailsBtn.className = "kids-bogo-card__details";
      detailsBtn.textContent = "View details";
      detailsBtn.addEventListener("click", function () {
        openDetail(product, currentVariant);
      });
      actions.appendChild(detailsBtn);
      body.appendChild(actions);

      card.appendChild(media);
      card.appendChild(body);
      card.addEventListener("click", function (e) {
        if (e.target.closest(".kids-bogo-card__details, .kids-bogo-swatch")) return;
        pickCard(card, product, currentVariant);
      });
      gridEl.appendChild(card);
    });

    const firstCard = gridEl.querySelector(".kids-bogo-card");
    if (firstCard) firstCard.click();

    filterBogoCards();
  }

  function readJson(res) {
    return res.text().then(function (text) {
      if (!text || text.charAt(0) === "<") throw new Error("invalid");
      return JSON.parse(text);
    });
  }

  function normalizeAjaxProducts(list) {
    return (list || [])
      .filter(productHasBogoTag)
      .map(function (p) {
        return {
          title: p.title,
          handle: p.handle,
          tags: p.tags || [],
          image: productImage(p),
          variants: (p.variants || []).map(function (v) {
            return {
              id: v.id,
              title: v.title,
              sku: v.sku || "",
              image: v.featured_image ? v.featured_image.src || "" : v.image || "",
              price: v.price,
              available: v.available !== false,
            };
          }),
        };
      });
  }

  function loadProducts() {
    if (productsCache && productsCache.length) return Promise.resolve(productsCache);

    const handle = collectionHandle();
    const local = cfg.products && cfg.products.length ? cfg.products : [];
    let cached = [];
    try {
      cached = JSON.parse(sessionStorage.getItem(PRODUCTS_KEY) || "[]");
    } catch (e) {}

    function useList(list) {
      const filtered = (list || []).filter(productHasBogoTag);
      productsCache = filtered;
      try {
        if (filtered.length) sessionStorage.setItem(PRODUCTS_KEY, JSON.stringify(filtered));
      } catch (e) {}
      return filtered;
    }

    if (handle) {
      return fetch("/collections/" + encodeURIComponent(handle) + "/products.json?limit=250")
        .then(readJson)
        .then(function (data) {
          const list = normalizeAjaxProducts(data.products || []);
          if (list.length) return useList(list);
          if (local.length >= cached.length) return useList(local);
          return useList(cached);
        })
        .catch(function () {
          if (local.length >= cached.length && local.length) return useList(local);
          if (cached.length) return useList(cached);
          return useList(local);
        });
    }

    if (local.length >= cached.length && local.length) return Promise.resolve(useList(local));
    if (cached.length) return Promise.resolve(useList(cached));
    return Promise.resolve(useList(local));
  }

  function openModal() {
    if (!modal) return;
    modal.hidden = false;
    document.body.style.overflow = "hidden";
    showList();
    if (gridEl) gridEl.innerHTML = "<p class='kids-bogo-empty'>Loading…</p>";
    loadProducts().then(renderGrid);
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = "";
    selected = null;
    pendingFirst = null;
    setFooterCta(false);
    showList();
  }

  modal &&
    modal.addEventListener("click", function (e) {
      if (e.target.closest("[data-kids-bogo-close]")) closeModal();
    });

  function cartAdd(variantId, extraProps) {
    const fd = new FormData();
    fd.append("id", String(variantId));
    fd.append("quantity", "1");
    fd.append("properties[_kids_bogo]", "1");
    if (extraProps) {
      Object.keys(extraProps).forEach(function (key) {
        fd.append("properties[" + key + "]", extraProps[key]);
      });
    }
    return fetch(cfg.cartAddUrl || "/cart/add.js", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/javascript",
      },
      body: fd,
    }).then(function (res) {
      return res.text();
    }).then(function (text) {
      if (!text || text.charAt(0) === "<") throw new Error("Could not add");
      const data = JSON.parse(text);
      if (data.status) throw new Error(data.description || data.message || "Could not add");
      return data;
    });
  }

  function discountCode() {
    return String(cfg.discountCode || "KIDSBOGO").trim() || "KIDSBOGO";
  }

  function cartHasDiscount(cart) {
    const code = discountCode().toUpperCase();
    if (!code || !cart) return false;
    return (cart.discount_codes || []).some(function (entry) {
      return String(entry.code || "").toUpperCase() === code && entry.applicable !== false;
    });
  }

  function applyCartDiscount() {
    const code = discountCode();
    if (!code) return Promise.resolve(null);
    const jsonReq = fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ discount: code }),
    }).then(readJson);
    return jsonReq.catch(function () {
      const body = new URLSearchParams();
      body.set("discount", code);
      return fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
        body: body.toString(),
      }).then(readJson);
    }).catch(function () {
      return null;
    });
  }

  function checkoutOrigin() {
    const host = window.location.hostname;
    if (host === "127.0.0.1" || host === "localhost") {
      const shop = cfg.shopDomain || (window.Shopify && Shopify.shop) || "";
      if (shop) return "https://" + shop;
    }
    return window.location.origin;
  }

  function goToCart() {
    window.location.href = cfg.cartUrl || "/cart";
  }

  function checkoutDiscountUrl() {
    const code = discountCode();
    const origin = checkoutOrigin();
    const redirect = encodeURIComponent("/checkout?discount=" + code);
    return origin + "/discount/" + encodeURIComponent(code) + "?redirect=" + redirect;
  }

  function goToCheckout() {
    const url = checkoutDiscountUrl();
    let sent = false;
    function go() {
      if (sent) return;
      sent = true;
      window.location.assign(url);
    }
    const timer = window.setTimeout(go, 800);
    applyCartDiscount().finally(function () {
      window.clearTimeout(timer);
      go();
    });
  }

  function cartChangeProps(item, extraProps) {
    const props = Object.assign({}, item.properties || {}, { _kids_bogo: "1" }, extraProps);
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: item.key,
        quantity: item.quantity,
        properties: props,
      }),
    }).then(readJson);
  }

  function pairLinesInCart(cart, secondVariantId) {
    const bogoItems = (cart.items || []).filter(isBogoCartItem);
    const firstLine =
      bogoItems.find(function (item) {
        return pairLabel(item) !== "2 of 2";
      }) || bogoItems[0];

    if (!firstLine) {
      const firstId = pendingFirst ? Number(pendingFirst.variantId) : null;
      if (firstId && firstId !== Number(secondVariantId)) {
        return cartAdd(firstId, pairProps("1 of 2")).then(function () {
          return cartAdd(secondVariantId, pairProps("2 of 2"));
        });
      }
      return cartAdd(secondVariantId, pairProps("2 of 2"));
    }

    const otherLine = bogoItems.find(function (item) {
      return item.key !== firstLine.key;
    });

    return cartChangeProps(firstLine, pairProps("1 of 2")).then(function () {
      if (otherLine) return cartChangeProps(otherLine, pairProps("2 of 2"));
      if (Number(firstLine.variant_id) === Number(secondVariantId)) return null;
      return cartAdd(secondVariantId, pairProps("2 of 2"));
    });
  }

  function addSelectedPair() {
    if (!selected || adding) return;
    adding = true;
    if (addBtn) addBtn.disabled = true;
    if (detailAdd) detailAdd.disabled = true;

    const secondId = Number(selected.variantId);
    const firstId = pendingFirst ? Number(pendingFirst.variantId) : null;
    const fromCheckout = !!(pendingFirst && pendingFirst.fromCheckout);
    const firstInCart = !!(pendingFirst && pendingFirst.inCart);

    function afterPair() {
      closeModal();
      pendingFirst = null;
      if (fromCheckout) return goToCheckout();
      return applyCartDiscount().then(function () {
        goToCart();
      });
    }

    const addFreshPair = function () {
      if (firstId && firstId !== secondId) {
        return cartAdd(firstId, pairProps("1 of 2")).then(function () {
          return cartAdd(secondId, pairProps("2 of 2"));
        });
      }
      if (firstId) {
        return cartAdd(firstId, pairProps("1 of 2")).then(function () {
          return cartAdd(secondId, pairProps("2 of 2"));
        });
      }
      return cartAdd(secondId, pairProps("2 of 2"));
    };

    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(readJson)
      .then(function (cart) {
        if (fromCheckout || firstInCart) return pairLinesInCart(cart, secondId);
        return addFreshPair();
      })
      .then(afterPair)
      .catch(function () {
        adding = false;
        if (addBtn) addBtn.disabled = false;
        if (detailAdd) detailAdd.disabled = false;
      })
      .finally(function () {
        adding = false;
      });
  }

  if (addBtn) addBtn.addEventListener("click", addSelectedPair);
  if (detailAdd) detailAdd.addEventListener("click", addSelectedPair);
  if (backBtn) backBtn.addEventListener("click", showList);
  if (searchEl) searchEl.addEventListener("input", filterBogoCards);

  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target.closest('form[data-type="add-to-cart-form"]');
      if (!formIsBogo(form)) return;
      const idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const submitter = e.submitter || document.activeElement;
      const buyNow =
        submitter &&
        submitter.closest &&
        submitter.closest(".shopify-payment-button, .shopify-payment-button__button, .additional-checkout-buttons");
      pendingFirst = { variantId: idInput.value, fromCheckout: !!buyNow };
      openModal();
    },
    true
  );

  function paymentHostFromEvent(e) {
    const path = typeof e.composedPath === "function" ? e.composedPath() : [];
    for (let i = 0; i < path.length; i++) {
      const node = path[i];
      if (!node || node.nodeType !== 1 || !node.closest) continue;
      const hit = node.closest(
        ".shopify-payment-button, .shopify-payment-button__button, .additional-checkout-buttons, shopify-accelerated-checkout, [data-shopify='payment-button']"
      );
      if (hit) return hit;
    }
    const t = e.target;
    if (t && t.closest) {
      return t.closest(
        ".shopify-payment-button, .shopify-payment-button__button, .additional-checkout-buttons, shopify-accelerated-checkout, [data-shopify='payment-button']"
      );
    }
    return null;
  }

  function interceptBuyItNow(e) {
    const payBtn = paymentHostFromEvent(e);
    if (!payBtn) return;
    if (payBtn.closest("cart-drawer, .drawer, #CartDrawer, #cart, form.cart__contents, form[action='/cart']")) return;
    const form =
      (payBtn.closest && payBtn.closest('form[data-type="add-to-cart-form"]')) ||
      document.querySelector('product-form[data-kids-bogo-product="1"] form[data-type="add-to-cart-form"]');
    if (!formIsBogo(form) && !cfg.isKidsProduct) return;
    const bogoForm = formIsBogo(form)
      ? form
      : document.querySelector('product-form[data-kids-bogo-product="1"] form[data-type="add-to-cart-form"]');
    if (!formIsBogo(bogoForm)) return;
    const idInput = bogoForm.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (modal && !modal.hidden) return;
    pendingFirst = { variantId: idInput.value, fromCheckout: true };
    openModal();
  }

  document.addEventListener("pointerdown", interceptBuyItNow, true);
  document.addEventListener("click", interceptBuyItNow, true);

  function wishlistButton(el) {
    if (!el || !el.closest) return null;
    return el.closest(
      ".wishlist-heart-btn, .wishlist-heart-container, .wishlist-btn, .wishlist-btn-container, [class*='wishlist-heart'], [class*='wishlist-button'], [aria-label*='ishlist' i]"
    );
  }

  function isWishlistRemove(btn) {
    const node = btn.closest("button, a, [role='button']") || btn;
    const label = String(
      (node.getAttribute("aria-label") || "") + " " + (node.getAttribute("title") || "")
    ).toLowerCase();
    if (label.indexOf("remove") !== -1 || label.indexOf("saved") !== -1) return true;
    if (node.getAttribute("aria-pressed") === "true") return true;
    const cls = String(node.className || "") + " " + String(btn.className || "");
    return /\b(active|added|filled|in-wishlist|is-in-wishlist|is-added)\b/i.test(cls);
  }

  function bogoHostFrom(el) {
    return (
      el.closest("[data-kids-bogo-product='1']") ||
      (cfg.isKidsProduct ? document.querySelector("product-form[data-kids-bogo-product='1']") : null)
    );
  }

  function variantIdFrom(host, el) {
    const attrHost = el.closest("[data-kids-bogo-variant], [data-variant-id], [data-variant_id]");
    const fromAttr =
      (attrHost &&
        (attrHost.getAttribute("data-kids-bogo-variant") ||
          attrHost.getAttribute("data-variant-id") ||
          attrHost.getAttribute("data-variant_id"))) ||
      (host && host.getAttribute("data-kids-bogo-variant")) ||
      el.getAttribute("data-variant-id") ||
      el.getAttribute("data-variant_id");
    if (fromAttr) return fromAttr;
    const form =
      (host && host.querySelector('[name="id"]')) ||
      document.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
    return form && form.value;
  }

  document.addEventListener(
    "click",
    function (e) {
      const btn = wishlistButton(e.target);
      if (!btn) return;
      if (isWishlistRemove(btn)) return;
      const host = bogoHostFrom(btn);
      if (!host && !cfg.isKidsProduct) return;
      const variantId = variantIdFrom(host, btn);
      if (!variantId) return;
      pendingFirst = { variantId: variantId };
      window.setTimeout(function () {
        openModal();
      }, 250);
    },
    true
  );

  function pairLabel(item) {
    const props = (item && item.properties) || {};
    return String(props._bogo || props.BOGO || props.bogo || "").trim();
  }

  function pairProps(label) {
    return { _bogo: label };
  }

  function isBogoCartItem(item) {
    if (!item) return false;
    const props = item.properties || {};
    if (props._kids_bogo === "1" || props["_kids_bogo"] === "1") return true;
    if (pairLabel(item)) return true;
    const handle = String(item.handle || "").toLowerCase();
    const title = String(item.title || "").toLowerCase();
    if (/\bkids?\b/.test(title)) return true;
    if (handle.indexOf("edge-y") !== -1 && title.indexOf("kid") !== -1) return true;
    if (!handle) return false;
    if ((cfg.products || []).some(function (p) { return p.handle === handle; })) return true;
    try {
      const stored = JSON.parse(sessionStorage.getItem(PRODUCTS_KEY) || "[]");
      return stored.some(function (p) {
        return p.handle === handle;
      });
    } catch (e) {
      return false;
    }
  }

  function bogoQty(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return isBogoCartItem(item) ? sum + item.quantity : sum;
    }, 0);
  }

  function incomplete(cart) {
    const qty = bogoQty(cart);
    return qty > 0 && qty % 2 !== 0;
  }

  function isCheckoutControl(el) {
    if (!el || el.closest(".shopify-payment-button, .additional-checkout-buttons")) return false;
    if (el.matches('[name="checkout"], .cart__checkout-button, #checkout, #CartDrawer-Checkout')) return true;
    const href = el.getAttribute("href") || "";
    return el.tagName === "A" && (/\/checkout(\?|$)/.test(href) || href.indexOf("/discount/") !== -1);
  }

  function startBogoCheckout(cart, fallbackHref, markedQty) {
    const qty = Math.max(bogoQty(cart), Number(markedQty || 0));
    if (qty > 0 && qty % 2 !== 0) {
      const unpaired =
        (cart.items || []).find(function (item) {
          return isBogoCartItem(item) && pairLabel(item) !== "2 of 2";
        }) || (cart.items || []).find(isBogoCartItem);
      pendingFirst = {
        fromCheckout: true,
        inCart: !!unpaired,
        variantId: unpaired ? unpaired.variant_id : null,
      };
      openModal();
      return;
    }
    if (qty >= 2 || (fallbackHref && fallbackHref.indexOf("/discount/") !== -1)) {
      goToCheckout();
      return;
    }
    if (fallbackHref) {
      window.location.href = fallbackHref;
      return;
    }
    window.location.href = "/checkout";
  }

  document.addEventListener(
    "click",
    function (e) {
      const btn = e.target.closest(
        '[name="checkout"], .cart__checkout-button, #checkout, #CartDrawer-Checkout, a[href*="/discount/"]'
      );
      if (!isCheckoutControl(btn)) return;

      const href = btn.getAttribute("href") || "";
      if (href.indexOf("/discount/") !== -1) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        goToCheckout();
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const markedQty = Number(btn.getAttribute("data-kids-bogo-qty") || 0);

      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(readJson)
        .then(function (cart) {
          startBogoCheckout(cart, href, markedQty);
        })
        .catch(function () {
          goToCheckout();
        });
    },
    true
  );

  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (!form || form.getAttribute("data-type") === "add-to-cart-form") return;
      const submitter = e.submitter || document.activeElement;
      if (!isCheckoutControl(submitter) && form.getAttribute("action") !== "/cart") return;
      if (!(submitter && (submitter.getAttribute("name") === "checkout" || isCheckoutControl(submitter)))) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(readJson)
        .then(function (cart) {
          const markedQty = Number((submitter && submitter.getAttribute("data-kids-bogo-qty")) || 0);
          startBogoCheckout(cart, "", markedQty);
        })
        .catch(function () {
          goToCheckout();
        });
    },
    true
  );

})();
